import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Button,
} from "reactstrap";
import axiosInstance from "../request";
import { URL } from "../api";
import { useLocation } from "react-router-dom"; 
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const RuleEngine = () => {
  const location = useLocation();

  const [customerId, setCustomerId] = useState("");
  const [loanId, setLoanId] = useState("");
  const [loading, setLoading] = useState(false);
  const [rules, setRules] = useState([]);
  const [reRunning, setReRunning] = useState(false);
  const [showRejectButton, setShowRejectButton] = useState(false);



const actionIdMap = {
  0: "reject",
  1: "pass",
  2: "hold",
  5: "break",
};

const statusToActionId = {
  reject: 0,
  pass: 1,
  hold: 2,
  break: 5,
};

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const cid = params.get("customerId");
    const lid = params.get("loanId");
    if (cid) setCustomerId(cid);
    if (lid) setLoanId(lid);
  }, [location.search]);


  useEffect(() => {
    if (customerId && loanId) {
      fetchRuleData();
    }
  }, [customerId, loanId]);


  const fetchRuleData = async () => {
    try {
      setLoading(true);
      const ts = Date.now();
      const response = await axiosInstance.get(
        `${URL.RULE_ENGINE}?customerId=${customerId}&loanId=${loanId}&_=${ts}`
      );
      const data = response.data;

      // const normalizedData = Array.isArray(data)
      //   ? data.map((rule) => ({
      //       ...rule,
      //       actionStatus: actionIdMap[rule.actionId] || "reject", 
      //     }))
      //   : [];
      const normalizedData = Array.isArray(data)
  ? data.map((rule) => ({
      ...rule,
      id: rule.id ?? rule.ruleId ?? rule.actionId,  // ✅ ensures id is always set
      actionStatus: actionIdMap[rule.actionId] || "reject",
    }))
  : [];


      setRules(normalizedData);
    } catch (err) {
  const errorMessage =
    (err.response && err.response.data && err.response.data.error) ||
    "Failed to fetch rule engine data";
  toast.error(errorMessage);
  if (errorMessage.includes("Customer is in status reject")) {
  setShowRejectButton(true);
}
  console.error("Error fetching rules:", err);
    } finally {
      setLoading(false);
    }
  };


const handleStatusChange = async (index, newStatus) => {
  const updatedRules = [...rules];
  const rule = updatedRules[index];


  if (rule.policyName === "Approval") {
    toast.warn("You cannot update status for Approval policy");
    return;
  }

  rule.actionStatus = newStatus;
  rule.actionId = statusToActionId[newStatus];
  setRules(updatedRules);

  try {
    const userId = localStorage.getItem("userId");
    await axiosInstance.post(URL.BRE_ACTION_UPDATE, {
      id: rule.id,
      actionStatus: newStatus,
      user_id: userId,
    });
    toast.success("Status updated successfully");
  } catch (err) {
    toast.error("Failed to update status");
    console.error("Update error:", err);
  }
};



  const handleReRun = async () => {
    setReRunning(true);
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `${URL.RERUN_RULE_ENGINE}?customerId=${customerId}&loanId=${loanId}`,
        { headers: { "Cache-Control": "no-cache" } }
      );

      const result = response.data;
      if (result.error) {
        toast.error(result.error || "Failed to re-run rules");
      } else {
        toast.success("Rules re-evaluated successfully");
        const normalizedData = Array.isArray(result)
          ? result.map((rule) => ({
              ...rule,
              actionStatus: actionIdMap[rule.actionId] || "reject",
            }))
          : [];
        // ✅ Sort by id ascending before setting
setRules(normalizedData.sort((a, b) => Number(a.id) - Number(b.id)));

      }
    } 
    catch (err) {
  const errorMessage =
    (err.response && err.response.data && err.response.data.error) ||
    "Failed to fetch rule engine data";
  toast.error(errorMessage);
  if (errorMessage.includes("Customer is in status reject")) {
  setShowRejectButton(true);
}
  console.error("Error fetching rules:", err);
    } finally {
      setReRunning(false);
      setLoading(false);
    }
  };

  return (
    <Col xs="12">
      <Card className="mb-4">
       <CardBody>
  <div className="d-flex justify-content-between align-items-center mb-3">
    <CardTitle tag="h5" className="text-uppercase text-muted m-0">
      Rule Engine
    </CardTitle>

    {showRejectButton && (
      <Button
        color="warning"
        size="sm"
        onClick={() =>
          (window.location.href = `#/RejectSummary?customer_id=${customerId}&loan_id=${loanId}`)
        }
      >
        Reject Summary
      </Button>
    )}
  </div>

          {loading ? (
            <p className="text-success font-weight-bold">Loading...</p>
          ) : rules.length === 0 ? (
            <p>No rules found.</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead className="thead-light">
                  <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Policy Name</th>
                    <th>Rule Name</th>
                    <th>Rule Code</th>
                    <th>Comment</th>
                    <th>Status</th>
                    <th>Updated By</th>
                  </tr>
                </thead>
                <tbody>
                  {rules.map((rule, index) => {
                   let bgColor = "#ffffff";
                    if (rule.actionStatus === "reject") {
                      bgColor = "#f8d7da"; 
                    } else if (rule.actionStatus === "hold") {
                      bgColor = "#fff3cd"; 
                    } else if (rule.actionStatus === "pass") {
                      bgColor = "#d4edda"; 
                    } else if (rule.actionStatus === "break") {
                      bgColor = "#d1ecf1"; 
                    }
                    return (
                      <tr key={index} style={{ backgroundColor: bgColor }}>
                        <td>{index + 1}</td>
                        <td>{rule.id}</td>
                        <td>{rule.policyName}</td>
                        <td>{rule.ruleName}</td>
                        <td>{rule.ruleCode}</td>
                        <td>{rule.comment}</td>
                     <td style={{ minWidth: "150px" }}>
                    {rule.policyName === "Approval" || rule.actionStatus === "break" ? (
                      <div
                        className="d-flex justify-content-center align-items-center fw-bold text-primary"
                        style={{
                          minHeight: "45px", 
                          border: "1px solid #ced4da",
                          borderRadius: "0.25rem",
                          backgroundColor: "#f8f9fa"
                        }}
                      >
                        {rule.actionStatus.charAt(0).toUpperCase() + rule.actionStatus.slice(1)}
                      </div>
                    ) : (
                      <select
                        className="form-select"
                        style={{ width: "100%" }}
                        value={rule.actionStatus}
                        onChange={(e) => handleStatusChange(index, e.target.value)}
                      >
                        <option value="reject">Reject</option>
                        <option value="pass">Pass</option>
                        <option value="hold">Hold</option>
                      </select>
                    )}
                      </td>

                        <td>{rule.updatedBy}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {rules.length > 0 && (
            <div className="text-end mt-3">
              <Button color="success" onClick={handleReRun} disabled={reRunning}>
                {reRunning ? "Re-running..." : "Re-run Rules"}
              </Button>
            </div>
          )}

          <ToastContainer />
        </CardBody>
      </Card>
    </Col>
  );
};


export default RuleEngine;
